import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerCollegeLookup } from '../../api/models';

export type TABLE_TYPE = Table<PlayerCollegeLookup>;

export const TABLE = 'playerCollegeLookup';
const SCHEMA = 'playerCollegeLookupId, sortId';

class PlayerCollegeLookupDatabase implements DataRepository<PlayerCollegeLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerCollegeLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerCollegeLookup, key: Key): Promise<PlayerCollegeLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerCollegeLookup[]): Promise<PlayerCollegeLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerCollegeLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PlayerCollegeLookupDB = new PlayerCollegeLookupDatabase(db);
